import logo from './logo.svg';
import './App.css';
import InternalProjectLinks from './Components/InternalProjectLinks'

function App() {
  return (
    <div className="App">
      <InternalProjectLinks></InternalProjectLinks>
    </div>
  );
}

export default App;
